import React from "react";
import { IoMdClose } from "react-icons/io";
import { Slider } from "@material-ui/core";
import { GrCircleInformation } from "react-icons/gr";
import { Modal, Typography, Button } from "components";

const ActiveInactiveAgentsModal = ({
  showModal,
  activeInactiveAgentQuery,
  handleModalClose,
  handleActiveInActiveAgentQueryChange,
}) => {
  return (
    <Modal showModal={showModal} onClose={handleModalClose} customPadding={"0"}>
      <div className="report-filter-modal">
        <div className="header">
          <div className="d-flex justify-content-end ">
            <IoMdClose
              className="cursor-pointer"
              onClick={() => handleModalClose()}
            />
          </div>
          <Typography className={"text-center"}>
            Set Threshold for Agent Report
          </Typography>
        </div>
        <div className="px-4 my-4">
          <Typography
            state="primary"
            variant="caption2"
            className={"text-center mb-3"}
          >
            Set the last number of days to check for agent activity
          </Typography>
          <Slider
            valueLabelDisplay="auto"
            value={activeInactiveAgentQuery.threshold}
            onChange={(e, value) => {
              handleActiveInActiveAgentQueryChange({
                name: "threshold",
                value,
              });
            }}
            size="large"
            style={{ width: "100%" }}
            color="primary"
            min={20}
            max={180}
          />
          <div className="filter-note">
            <span>Note that</span>{" "}
            <span>
              <GrCircleInformation />
            </span>{" "}
            <span>Maximum of 180 days (last 6 months) can be selected</span>
          </div>
          <div className="filter-note-detail">
            <span>
              According to your set threshold, agents that didn't perform any
              transaction for the selected transaction type within the last
            </span>{" "}
            <span className="bold">{activeInactiveAgentQuery.threshold}</span>{" "}
            days will be considered as <span>Inactive Agents</span>, while
            agents that perform 1 or more transactions for the selected
            transaction type in the last{" "}
            <span className="bold">{activeInactiveAgentQuery.threshold}</span>{" "}
            days that period will be considered{" "}
            <span className="bold">Active Agents</span>.
          </div>
          <Button
            label="Apply"
            size="xs"
            className={"mx-auto"}
            onClick={() => handleModalClose()}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ActiveInactiveAgentsModal;
